import 'whatwg-fetch'
import 'core-js/stable'
import 'regenerator-runtime/runtime' // Required for async/await transpilation

if (typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = function (callback) {
    Promise.resolve()
      .then(callback)
      .catch(function (e) {
        setTimeout(function () {
          throw e
        }, 0)
      })
  }
}

import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = ResizeObserver
import 'abort-controller/polyfill'

if (!window.crypto.randomUUID) {
  window.crypto.randomUUID = function () {
    // @ts-ignore
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    })
  }
}

import '@lib/es/style.css'
import '../style.css'

import { createRoot } from 'react-dom/client'
import App from './SimpleApp'

const init = () => {
  const container = document.getElementById('root')
  if (container) {
    createRoot(container).render(<App />)
  } else {
    // If it fails, we try again in 100ms
    setTimeout(init, 100)
  }
}

init()
